// @ts-ignore
import GLightbox from 'glightbox';

export class Lightbox {
    selector: string;
    lightboxes: NodeListOf<HTMLElement>;

    constructor() {
        this.selector = 'data-lightbox';
        this.lightboxes = document.querySelectorAll('[' + this.selector + ']');
        this.init();
    }

    init() {
        // @ts-ignore
        const TYPO3 = window.TYPO3 || {};
        const showMoreLabel = TYPO3.lang === undefined ? 'Show more' : TYPO3.lang['general.showMore'];
        this.lightboxes.forEach((lightbox) => {
            let key = lightbox.getAttribute(this.selector);
            const glightbox = GLightbox({
                selector: '[' + this.selector + '="' + key + '"]',
                zoomable: false,
                autoplayVideos: false,
                moreText: showMoreLabel,
                moreLength: 120,
                svg: {
                    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/></svg>',
                    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
                    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>'
                },
            });
        });
    }

}
document.addEventListener("DOMContentLoaded", function() {
    new Lightbox();
});
